import React, { useEffect, useState } from "react";
import { fetchJobDetail } from "../api";
import RowResultsTable from "./RowResultsTable";

export default function HistoryDetail({ jobId }) {
  const [job, setJob] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    fetchJobDetail(jobId)
      .then((body) => {
        if (cancelled) return;
        setJob(body.job);
        setLoading(false);
      })
      .catch((e) => {
        if (cancelled) return;
        setError(e.message || String(e));
        setLoading(false);
      });
    return () => { cancelled = true; };
  }, [jobId]);

  if (loading) return <div className="bfr-history-detail">Loading…</div>;
  if (error) return <div className="bfr-history-detail">Error: {error}</div>;
  if (!job) return null;

  return (
    <div className="bfr-history-detail">
      <RowResultsTable rows={job.rows || []} />
    </div>
  );
}
